import React from 'react'

import window from 'browser-lib/window'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { login, useTrackUserPilotMovement } from 'common/user-pilot-helper'
import { selectFeatures } from 'store/college'

export class UserTrackingStartup extends React.Component {
  static propTypes = {
    features: PropTypes.object,
    userId: PropTypes.string,
    scid: PropTypes.number,
    email: PropTypes.string,
    roles: PropTypes.array,
    isShadow: PropTypes.bool,
    name: PropTypes.string,
    children: PropTypes.node,
    collegeFeatures: PropTypes.object,
  }
  componentDidMount() {
    const { email, roles, userId, scid, isShadow, collegeFeatures, collegeName, confirmationDate } = this.props
    window.localStorage.removeItem('sessionId') // clear the session ID used by the public-facing app
    login({
      email,
      roles,
      userId,
      isShadow,
      scid,
      collegeName,
      collegeFeatures,
      confirmationDate,
    })
  }
  componentDidUpdate(prevProps) {
    const { userId, scid, email, roles, isShadow, collegeFeatures, collegeName, confirmationDate } = this.props
    if (userId !== get(prevProps, 'userId')) {
      login({
        email,
        roles,
        userId,
        isShadow,
        scid,
        collegeFeatures,
        collegeName,
        confirmationDate,
      })
    }
  }
  render() {
    return this.props.children
  }
}

const StoreConnectedUserTrackingStartup = connect((store) => ({
  userId: get(store.user.record, 'Id'),
  scid: get(store.user.record, 'Scid'),
  collegeName: get(store.user.record, 'CollegeName'),
  email: get(store.user.record, 'Email'),
  roles: get(store.user.record, 'Roles'),
  isShadow: get(store.user.record, 'IsShadow'),
  name: `${get(store.user.record, 'FirstName')} ${get(store.user.record, 'LastName')}`,
  confirmationDate: get(store.user.record, 'ConfirmationDate'),
  features: store.features.record,
  collegeFeatures: selectFeatures(store),
}))(UserTrackingStartup)
const HookConnectedStoreConnectedUserTrackingStartup = (props) => {
  useTrackUserPilotMovement()
  return <StoreConnectedUserTrackingStartup {...props} />
}
export default HookConnectedStoreConnectedUserTrackingStartup
